import BaseService from '@/services/BaseService'
import {http} from './config'

class ContratoService {
    gerarContratoInstalacaoPiscina(vendaId){
        return http.get(`/v1/contrato/instalacao-piscina/${vendaId}/gerar`)
    }
}

export default new ContratoService